import React, { Dispatch, ReactNode, SetStateAction, useState } from 'react';
import List from '@mui/material/List';
import { Autocomplete, TextField } from '@mui/material';
import { IDistrictList } from 'src/basic-rest/types';
import { IGetID } from './Address';
import { AddressLoading, AddressNotFound } from './utils';
import { useFetchDistrictData } from 'src/basic-rest/useFetchAddressData';
import { Box } from '@mui/system';
type IProps = {
  checked: IGetID;
  setChecked: Dispatch<SetStateAction<IGetID>>;
};

function FilterDistrict({ checked, setChecked }: IProps) {
  const [open, setOpen] = useState(false);
  const [reload, setReload] = useState(false);
  const {
    data: districtData,
    fetchDistrictData,
    loading,
    setData,
  } = useFetchDistrictData();

  React.useEffect(() => {
    if (checked.division) {
      fetchDistrictData({
        division_id: checked.division.division_id,
      });
    } else {
      fetchDistrictData();
    }
  }, [checked.division, reload]);

  let content: ReactNode;
  if (loading) {
    content = <AddressLoading />;
  }
  if (!loading && districtData.length === 0) {
    content = <AddressNotFound />;
  }
  if (!loading && districtData.length > 0) {
    content = (
      <Autocomplete
        size='small'
        getOptionLabel={(option: IDistrictList) => option.district_name}
        id='combo-box-demo'
        options={districtData}
        renderOption={(params: any, option: IDistrictList) => (
          <Box component='li' {...params}>
            {option.district_name}
          </Box>
        )}
        renderInput={(params) => (
          <TextField {...params} label='Select district' variant='outlined' />
        )}
        onChange={(_event, value: IDistrictList) => {
          setChecked({ ...checked, district: value, thana: null, area: null });
        }}
      />
    );
  }

  return (
    <>
      <List
        sx={{
          width: '100%',
        }}
      >
        {content}
      </List>
    </>
  );
}

export default FilterDistrict;
